import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Modal from '@mui/material/Modal';
import Fab from '@mui/material/Fab';
import Clear from '@mui/icons-material/Clear';
import { stringIsNullOrEmpty } from '../../../util/strings';
import InfoCircleIcon from '../../../component/icon/InfoCircleIcon';
import TickCircleIcon from '../../../component/icon/TickCircleIcon';
import ExclamationCircleIcon from '../../../component/icon/ExclamationCircleIcon';
import ExclamationTriangleIcon from '../../../component/icon/ExclamationTriangleIcon';
import Button from './Button';
import Inline from './Inline';

class AlertModal extends Component {
    render() {
        const { open, onClose, variant } = this.props;

        return (
            <Modal // `disableBackdropClick` is removed by codemod.
                // You can find more details about this breaking change in [the migration guide](https://mui.com/material-ui/migration/v5-component-changes/#modal)

                className="workqueue-page"
                open={open}
                aria-labelledby="alert-modal-title"
                aria-describedby="alert-modal-description"
                disableEscapeKeyDown={false}
            >
                <div className={`modal modal--alert modal--alert--${variant || 'primary'}`}>
                    <div className="paper">
                        <Fab color="primary" aria-label="Close" className="fab close" onClick={() => onClose()}>
                            <Clear />
                        </Fab>

                        {this.renderContent()}
                    </div>
                </div>
            </Modal>
        );
    }

    renderContent() {
        const {
            children,
            variant,
            primaryAction,
            onClickPrimaryAction,
            secondaryAction,
            onClickSecondaryAction,
            onClose,
            disablePrimaryAction = false,
            disableSecondaryAction = false
        } = this.props;

        let icon;
        let buttonVariant;
        if (variant === 'save') {
            icon = <TickCircleIcon />;
            buttonVariant = 'confirmation';
        } else if (variant === 'warning') {
            icon = <ExclamationTriangleIcon />;
            buttonVariant = 'urgent';
        } else if (variant === 'error') {
            icon = <ExclamationCircleIcon />;
            buttonVariant = 'decline';
        } else {
            icon = <InfoCircleIcon />;
            buttonVariant = 'primary';
        }

        return (
            <div className="alert-content">
                <div className="icon">{icon}</div>
                <div className="content">{children}</div>
                <Inline>
                    {!stringIsNullOrEmpty(secondaryAction) && (
                        <Button variant="secondary" disabled={disableSecondaryAction} onClick={onClickSecondaryAction}>
                            {secondaryAction}
                        </Button>
                    )}
                    {!stringIsNullOrEmpty(primaryAction) && (
                        <Button variant={buttonVariant} disabled={disablePrimaryAction} onClick={onClickPrimaryAction}>
                            {primaryAction}
                        </Button>
                    )}
                    {stringIsNullOrEmpty(primaryAction) && stringIsNullOrEmpty(secondaryAction) && (
                        <Button variant="modal-action modal-action--cancel" onClick={onClose}>
                            Close
                        </Button>
                    )}
                </Inline>
            </div>
        );
    }
}

export default withStyles({})(AlertModal);
